export const FILTER_TITLE = `סינון נכסים על המפה`;
export const SEARCH_BUTTON_TEXT = "נתונים לפי איזור";
export const FILTER_DATE_CTA = `בחרו חודש/טווח חודשים`;
export const FILTER_ROOMS_CTA = `בחרו מספר חדרים/טווח מספר חדרים`;
export const FILTER_BUTTON = `סנן נכסים`;
export const BACK_TO_SEARCH_BUTTON = `לחישוב שכר הדירה שלי`;
